/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Keyword API
 * Service provides a keyword search and related data.
 * OpenAPI spec version: 0.0.0
 */
import { adapter } from './adapter';
/**
 * a list of hotels
 */
export interface Hotels {
  total: number;
  items: Hotel[];
}

/**
 * a list of regions
 */
export interface Regions {
  total: number;
  items: Keyword[];
}

/**
 * a list of hotel ids
 */
export interface HotelIds {
  total: number;
  items: HotelId[];
}

/**
 * the hotel id
 */
export type HotelId = string;

/**
 * hotel data
 */
export interface Hotel {
  id: string;
  name: string;
  updated: string;
  rank?: number;
  category?: number;
  categoryType?: string;
  city: Keyword;
  country: Keyword;
  destinations?: Keyword[];
  multicountries: Keyword[];
  continent: Keyword;
  address: Address;
  location: Location;
  travelTypes: TravelTypes[];
}

/**
 * postal address
 * @nullable
 */
export type Address = {
  city?: string;
  countryCode: string;
  street?: string;
  streetNumber?: string;
  zip?: string;
} | null;

/**
 * set of geocoordinates
 * @nullable
 */
export type Location = {
  lat: number;
  lon: number;
} | null;

/**
 * a list of keywords
 */
export interface Keywords {
  total: number;
  items: Keyword[];
}

/**
 * keyword data.
 * @nullable
 */
export type Keyword = {
  id: string;
  keyword: string;
  type: string;
  updated: string;
  meta?: Meta;
  travelTypes?: TravelTypes[];
} | null;

/**
 * additional meta information, depending on the component's type
 */
export interface Meta { [key: string]: unknown }

/**
 * available travelTypes
 */
export type TravelTypes = typeof TravelTypes[keyof typeof TravelTypes];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TravelTypes = {
  packageTour: 'packageTour',
  ownArrival: 'ownArrival',
} as const;

/**
 * available hotel fields
 */
export type HotelFields = typeof HotelFields[keyof typeof HotelFields];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HotelFields = {
  name: 'name',
  updated: 'updated',
  rank: 'rank',
  category: 'category',
  categoryType: 'categoryType',
  city: 'city',
  country: 'country',
  destinations: 'destinations',
  multicountries: 'multicountries',
  continent: 'continent',
  address: 'address',
  location: 'location',
  travelTypes: 'travelTypes',
} as const;

/**
 * keyword types
 */
export type KeywordTypes = typeof KeywordTypes[keyof typeof KeywordTypes];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const KeywordTypes = {
  hotel: 'hotel',
  chain: 'chain',
  city: 'city',
  destination: 'destination',
  country: 'country',
  multicountry: 'multicountry',
  continent: 'continent',
} as const;

/**
 * region keyword types
 */
export type KeywordTypesRegion = typeof KeywordTypesRegion[keyof typeof KeywordTypesRegion];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const KeywordTypesRegion = {
  city: 'city',
  destination: 'destination',
  country: 'country',
  multicountry: 'multicountry',
  continent: 'continent',
} as const;

/**
 * successful hotel id list response
 */
export type HotelIdsResponse = HotelIds;

/**
 * successful hotel list response
 */
export type HotelsResponse = Hotels;

/**
 * successful regions list response
 */
export type RegionsResponse = Regions;

/**
 * successful single hotel response
 */
export type HotelResponse = Hotel;

/**
 * successful keyword list response
 */
export type KeywordsResponse = Keywords;

/**
 * successful keyword response
 */
export type KeywordResponse = Keyword;

export type ErrorResponse = {
  /** Error code */
  code: number;
  /** Error message */
  message: string;
};

export type AutocompleteParams = {
/**
 * phrase to search for
 */
q: string;
/**
 * travelTypes filter parameter (packageTour, ownArrival)
 */
travelTypes?: TravelTypes[];
/**
 * the max number of returned keywords
 */
limit?: number;
};

export type KeywordsHotelsParams = {
/**
 * travelTypes filter parameter (packageTour, ownArrival)
 */
travelTypes?: TravelTypes[];
/**
 * fields filter parameter (name, updated, rank, category, categoryType, city, country, destinations, multicountries, continent, address, location, travelTypes)
 */
fields?: HotelFields[];
/**
 * the max number of returned keywords
 */
limit?: number;
};

export type KeywordsHotelIdsParams = {
/**
 * travelTypes filter parameter (packageTour, ownArrival)
 */
travelTypes?: TravelTypes[];
};

export type KeywordsParams = {
/**
 * keyword types filter parameter (continent, multicountry, country, destination, city, hotel)
 */
types?: KeywordTypes[];
/**
 * the max number of returned keywords
 */
limit?: number;
};

export type HotelsParams = {
/**
 * travelTypes filter parameter (packageTour, ownArrival)
 */
travelTypes?: TravelTypes[];
/**
 * the max number of returned hotels, beware of ids parameter - if limit is lower that the count of ids you will get a subset of your requested ids
 */
limit?: number;
};

export type HotelRegionsParams = {
/**
 * keyword region types filter parameter (continent, multicountry, country, destination, city)
 */
types?: KeywordTypesRegion[];
};

export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;

/**
 * Provides a list of keywords matching the requested phrase
 */
export type autocompleteResponse200 = {
  data: KeywordsResponse
  status: 200
}

export type autocompleteResponseDefault = {
  data: ErrorResponse
  status: Exclude<HTTPStatusCodes, 200>
}
    
export type autocompleteResponseComposite = autocompleteResponse200 | autocompleteResponseDefault;
    
export type autocompleteResponse = autocompleteResponseComposite & {
  headers: Headers;
}

export const getAutocompleteUrl = (params: AutocompleteParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/autocomplete?${stringifiedParams}` : `/autocomplete`
}

export const autocomplete = async (params: AutocompleteParams, options?: RequestInit): Promise<autocompleteResponse> => {
  
  return adapter<autocompleteResponse>(getAutocompleteUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Provides all hotels for a keyword
 */
export type keywordsHotelsResponse200 = {
  data: HotelsResponse
  status: 200
}

export type keywordsHotelsResponseDefault = {
  data: ErrorResponse
  status: Exclude<HTTPStatusCodes, 200>
}
    
export type keywordsHotelsResponseComposite = keywordsHotelsResponse200 | keywordsHotelsResponseDefault;
    
export type keywordsHotelsResponse = keywordsHotelsResponseComposite & {
  headers: Headers;
}

export const getKeywordsHotelsUrl = (id: string,
    params?: KeywordsHotelsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/keywords/${id}/hotels?${stringifiedParams}` : `/keywords/${id}/hotels`
}

export const keywordsHotels = async (id: string,
    params?: KeywordsHotelsParams, options?: RequestInit): Promise<keywordsHotelsResponse> => {
  
  return adapter<keywordsHotelsResponse>(getKeywordsHotelsUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Provides all hotel-Ids for a keyword
 */
export type keywordsHotelIdsResponse200 = {
  data: HotelIdsResponse
  status: 200
}

export type keywordsHotelIdsResponseDefault = {
  data: ErrorResponse
  status: Exclude<HTTPStatusCodes, 200>
}
    
export type keywordsHotelIdsResponseComposite = keywordsHotelIdsResponse200 | keywordsHotelIdsResponseDefault;
    
export type keywordsHotelIdsResponse = keywordsHotelIdsResponseComposite & {
  headers: Headers;
}

export const getKeywordsHotelIdsUrl = (id: string,
    params?: KeywordsHotelIdsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/keywords/${id}/hotelIds?${stringifiedParams}` : `/keywords/${id}/hotelIds`
}

export const keywordsHotelIds = async (id: string,
    params?: KeywordsHotelIdsParams, options?: RequestInit): Promise<keywordsHotelIdsResponse> => {
  
  return adapter<keywordsHotelIdsResponse>(getKeywordsHotelIdsUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Provides the complete dataset for a keyword.
 */
export type keywordsByIdResponse200 = {
  data: KeywordResponse
  status: 200
}

export type keywordsByIdResponseDefault = {
  data: ErrorResponse
  status: Exclude<HTTPStatusCodes, 200>
}
    
export type keywordsByIdResponseComposite = keywordsByIdResponse200 | keywordsByIdResponseDefault;
    
export type keywordsByIdResponse = keywordsByIdResponseComposite & {
  headers: Headers;
}

export const getKeywordsByIdUrl = (id: string,) => {


  

  return `/keywords/${id}`
}

export const keywordsById = async (id: string, options?: RequestInit): Promise<keywordsByIdResponse> => {
  
  return adapter<keywordsByIdResponse>(getKeywordsByIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Provides all keywords
 */
export type keywordsResponse200 = {
  data: KeywordsResponse
  status: 200
}

export type keywordsResponseDefault = {
  data: ErrorResponse
  status: Exclude<HTTPStatusCodes, 200>
}
    
export type keywordsResponseComposite = keywordsResponse200 | keywordsResponseDefault;
    
export type keywordsResponse = keywordsResponseComposite & {
  headers: Headers;
}

export const getKeywordsUrl = (params?: KeywordsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/keywords?${stringifiedParams}` : `/keywords`
}

export const keywords = async (params?: KeywordsParams, options?: RequestInit): Promise<keywordsResponse> => {
  
  return adapter<keywordsResponse>(getKeywordsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Provides a list of hotels
 */
export type hotelsResponse200 = {
  data: HotelsResponse
  status: 200
}

export type hotelsResponseDefault = {
  data: ErrorResponse
  status: Exclude<HTTPStatusCodes, 200>
}
    
export type hotelsResponseComposite = hotelsResponse200 | hotelsResponseDefault;
    
export type hotelsResponse = hotelsResponseComposite & {
  headers: Headers;
}

export const getHotelsUrl = (params?: HotelsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/hotels?${stringifiedParams}` : `/hotels`
}

export const hotels = async (params?: HotelsParams, options?: RequestInit): Promise<hotelsResponse> => {
  
  return adapter<hotelsResponse>(getHotelsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Provides the complete dataset for a hotel.
 */
export type hotelByIdResponse200 = {
  data: HotelResponse
  status: 200
}

export type hotelByIdResponseDefault = {
  data: ErrorResponse
  status: Exclude<HTTPStatusCodes, 200>
}
    
export type hotelByIdResponseComposite = hotelByIdResponse200 | hotelByIdResponseDefault;
    
export type hotelByIdResponse = hotelByIdResponseComposite & {
  headers: Headers;
}

export const getHotelByIdUrl = (id: string,) => {


  

  return `/hotels/${id}`
}

export const hotelById = async (id: string, options?: RequestInit): Promise<hotelByIdResponse> => {
  
  return adapter<hotelByIdResponse>(getHotelByIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Provides the complete region dataset for a hotel.
 */
export type hotelRegionsResponse200 = {
  data: RegionsResponse
  status: 200
}

export type hotelRegionsResponseDefault = {
  data: ErrorResponse
  status: Exclude<HTTPStatusCodes, 200>
}
    
export type hotelRegionsResponseComposite = hotelRegionsResponse200 | hotelRegionsResponseDefault;
    
export type hotelRegionsResponse = hotelRegionsResponseComposite & {
  headers: Headers;
}

export const getHotelRegionsUrl = (id: string,
    params?: HotelRegionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/hotels/${id}/regions?${stringifiedParams}` : `/hotels/${id}/regions`
}

export const hotelRegions = async (id: string,
    params?: HotelRegionsParams, options?: RequestInit): Promise<hotelRegionsResponse> => {
  
  return adapter<hotelRegionsResponse>(getHotelRegionsUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
